import Lottie from 'lottie-react';
import animation from '../../assets/json/Loader.json';

type MLoaderProps = {
  loop?: boolean | number;
  onComplete?: () => void;
  onLoopComplete?: () => void;
};
export const MLoader = ({
  onComplete = () => {},
  onLoopComplete = () => {},
  loop = true,
}: MLoaderProps) => (
  <Lottie
    animationData={animation}
    onComplete={onComplete}
    onLoopComplete={onLoopComplete}
    loop={loop}
  />
);
